module.exports = __webpack_public_path__ + "img/adapt.ea9d7a5c.png";